import {
    FROM_CURRENCY_SET_VALUE,
    setFromCurrencyValid,
    TO_CURRENCY_SET_VALUE,
    setToCurrencyValid,
    EXCHANGE_RATE_SET_VALUE,
    setExchangeRateValid,
} from '../../../actions/eaTravelRates/update';
import { validateSingleSelection, validateNumber } from '@om/validation';

import { validationIsEqual } from '../status';
let prevValidationAction = null;

export const updateFormValidation = (store, next, action) => {
    //const quoteForm = getQuotationForm(store.getState());
    const validationAction = (() => {
        let error = null;

        switch (action.type) {
            case FROM_CURRENCY_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Currency',
                });
                return setFromCurrencyValid(error);

            case TO_CURRENCY_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Currency',
                });
                return setToCurrencyValid(error);

            case EXCHANGE_RATE_SET_VALUE:
                error = validateNumber(action.value, { min: 0, subject: 'Exchange Rate' });
                return setExchangeRateValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
